import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Wrapper, Button, Menu, MenuItem } from 'react-aria-menubutton';
import _ from 'lodash';
import classNames from 'classnames';

import { RADIUS_OPTIONS } from '../globals/config';
import { I18N } from '../globals/wp';

import styles from './radius-selector.pcss';

/**
 * Powers the geolocation api request and handling.
 */

export default class RadiusSelector extends PureComponent {
	static propTypes = {
		handleUpdateRadius: PropTypes.func,
		radius: PropTypes.number.isRequired,
	};

	static defaultProps = {
		handleUpdateRadius: () => {},
	};

	getRadiusObjectFromLabel = (label) => {
		return _.find(RADIUS_OPTIONS, {label});
	};

	handleUpdateRadius = (value) => {
		const radiusObject = this.getRadiusObjectFromLabel(value);
		this.props.handleUpdateRadius(radiusObject.value);
	};

	render() {
		const menuItems = RADIUS_OPTIONS.map((option, i) => {
			return (
				<li key={i}>
					<MenuItem className={styles.menuItem}>
						{option.label}
					</MenuItem>
				</li>
			);
		});

		const radiusObject = _.find(RADIUS_OPTIONS, { value: this.props.radius });

		const buttonClasses = classNames({
			[styles.trigger]: true,
		});

		return (
			<Wrapper
				className={styles.container}
				onSelection={this.handleUpdateRadius}
			>
				<Button className={buttonClasses}>
					{I18N.search_radius_button}{radiusObject.label}
				</Button>
				<Menu className={styles.menu}>
					<ul>{menuItems}</ul>
				</Menu>
			</Wrapper>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/radius-selector.js